
// Custom Selects — robust init for Shopify/sections
// Fixes: runs after DOM is ready, re-inits on dynamic loads, and logs if wiring fails.

(function () {
  const VALUE_SEL = 'input.product-variant-id, input[name="id"]';

  // Deep query that pierces shadow roots recursively
  function deepQuery(root, selector) {
    if (!root) return null;
    if (root.matches?.(selector)) return root;
    const direct = root.querySelector?.(selector);
    if (direct) return direct;

    const stack = Array.from(root.children || []);
    while (stack.length) {
      const node = stack.shift();
      if (!node) continue;
      if (node.matches?.(selector)) return node;
      const q = node.querySelector?.(selector);
      if (q) return q;
      if (node.shadowRoot) {
        const s = node.shadowRoot.querySelector(selector);
        if (s) return s;
        stack.push(...Array.from(node.shadowRoot.children || []));
      }
      stack.push(...Array.from(node.children || []));
    }
    return null;
  }

  function closeAll() {
    document.querySelectorAll('.custom-select.open').forEach(cs => {
      cs.classList.remove('open');
      const list = cs.querySelector('.select-items');
      if (list) list.style.display = 'none';
    });
  }

  // Locate the hidden input when it lives inside a sibling container (e.g., <product-form>…)
  function findTargetInput(cs) {
    // 1) look in following siblings (and their descendants/shadow roots)
    for (let el = cs.nextElementSibling; el; el = el.nextElementSibling) {
      const found = (el.matches?.(VALUE_SEL) && el) || deepQuery(el, VALUE_SEL);
      if (found) return found;
    }
    // 2) nearest logical container
    const container = cs.closest('form, [data-section-id], .product, .card, section, article') || cs.parentElement;
    const inContainer = deepQuery(container, VALUE_SEL);
    if (inContainer) return inContainer;

    // 3) global fallback
    return document.querySelector(VALUE_SEL);
  }

  function initOne(cs) {
    if (!cs || cs.dataset.csInit === '1') return;
    const selected = cs.querySelector('.select-selected');
    const list = cs.querySelector('.select-items');
    const options = list ? Array.from(list.querySelectorAll('[data-value]')) : [];
    if (!selected || !list || !options.length) return;

    const input = findTargetInput(cs);
    if (!input) {
      return;
    }

    const open = () => { closeAll(); list.style.display = 'block'; cs.classList.add('open'); };
    const close = () => { list.style.display = 'none'; cs.classList.remove('open'); };

    selected.setAttribute('tabindex', '0');
    selected.addEventListener('click', (e) => { e.stopPropagation(); cs.classList.contains('open') ? close() : open(); });
    selected.addEventListener('keydown', (e) => {
      if (['Enter',' ','ArrowDown'].includes(e.key)) { e.preventDefault(); open(); (options[0] || selected).focus(); }
      if (e.key === 'Escape') close();
    });

    function choose(item) {
      const val = item.dataset.value;
      selected.textContent = item.textContent;
      selected.dataset.value = val;
      if (input) {
        input.value = val;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      close();
      selected.focus();
    }

    options.forEach((item, i) => {
      item.setAttribute('tabindex', '0');
      item.addEventListener('click', (e) => { e.stopPropagation(); choose(item); });
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(item); }
        else if (e.key === 'ArrowDown') { e.preventDefault(); (options[i + 1] || options[0]).focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); (options[i - 1] || options[options.length - 1]).focus(); }
        else if (e.key === 'Escape') { e.preventDefault(); close(); selected.focus(); }
      });
    });

    // Sync label from existing input value
    if (input?.value) {
      const init = options.find(o => o.dataset.value == input.value);
      if (init) selected.textContent = init.textContent;
    }

    cs.dataset.csInit = '1';
  }

  function initAll() {
    document.querySelectorAll('.custom-select').forEach(initOne);
  }

  // Close when clicking outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.custom-select')) closeAll();
  });

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-initialize when Shopify dynamically injects sections/components
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', initAll);

  // Also observe DOM mutations (fallback for any ajax/theme updates)
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.type === 'childList' && (m.addedNodes?.length || m.removedNodes?.length)) {
        initAll();
        break;
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
